import api from '@/lib/axios';
import { API_ENDPOINTS } from '@/constants/api-endpoints';

export type NotificationTarget = 'all' | 'drivers' | 'customers' | 'user';

export interface BroadcastPayload {
  target: NotificationTarget;
  user_id?: string;
  title: string;
  body: string;
  data?: Record<string, string>;
}

export interface BroadcastResult {
  success: boolean;
  target: NotificationTarget;
  fcm: { success: number; failure: number };
  inApp: number;
}

export const pushNotificationsApi = {
  broadcast: async (payload: BroadcastPayload): Promise<BroadcastResult> => {
    const res = await api.post<{ success: boolean; data: BroadcastResult }>(
      API_ENDPOINTS.PUSH_NOTIFICATIONS.BROADCAST,
      payload,
    );
    return res.data.data;
  },
};
